import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

import { AirValidationResponse } from '@app/entities/air-validation.response';
import { SearchBy } from '@shared/base-search-bar/entities/search.entities';
import { VehicleValidateResponse } from '@autos/entities/vehicle-validate.response';
import { HotelValidationResponse } from '@booking/entities/hotel-validation.response';
import { ActivitiesValidateResponse } from '@activities/entities/activities-booking';

@Component({
  selector: 'app-policies-detail',
  templateUrl: './policies-detail.component.html',
  styleUrls: ['./policies-detail.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PoliciesDetailComponent {

  @Input() airValidation: AirValidationResponse | AirValidationResponse[];
  @Input() hotelValidation: HotelValidationResponse;
  @Input() autoValidation: VehicleValidateResponse;
  @Input() activitiesValidation: ActivitiesValidateResponse;
  @Input() policiesType: SearchBy;
  @Input() isMobile: boolean;
  @Input() showFreeCancellation: boolean = true;
  @Input() titleClass: string;
  @Input() airTermsBySector: boolean;
  @Input() isBookingView = false;

  public readonly policiesDetailType = SearchBy;

  constructor() { }

}
